import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, InputGroup } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require("../../../../app/shared/Strings");
const OrganizationActions = require('../../actions/OrganizationActions');
const ProjectStore = require('../../stores/ProjectStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
import Tooltip from '../common/Tooltip';
import ConfirmModal from '../modal/ConfirmModal';
import SelectableProjectsActivitiesTree from '../common/SelectableProjectsActivitiesTree';
import { UpdateTagNameWarning, TagNameInfo } from './OrgIntegrationTagInfoWarnings';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    tagRecord: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        tag: PropTypes.string.isRequired,
        description: PropTypes.string,
        user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }).isRequired,
    className: PropTypes.string,
    onDelete: PropTypes.func.isRequired,
};

const defaultProps = {
    className: ''
};

class OrgIntegrationTagEditor extends React.Component {
    constructor(props) {
        super(props);

        this.getDefaultTagUpdates = this.getDefaultTagUpdates.bind(this);

        this.state = {
            newTagName: null,
            newTagDescription: null,
            showConfirmUpdateTagModal: false,
            showConfirmDeleteTagModal: false,
            tagUpdates: this.getDefaultTagUpdates(),
            tagManageActionId: null,
            tagManageError: null,
        };

        this.onChangeTagName = this.onChangeTagName.bind(this);
        this.onChangeTagDescription = this.onChangeTagDescription.bind(this);
        this.onUpdateTagName = this.onUpdateTagName.bind(this)
        this.onUpdateTagDescription = this.onUpdateTagDescription.bind(this);
        this.setConfirmUpdateTagModalState = this.setConfirmUpdateTagModalState.bind(this);
        this.setConfirmDeleteTagModalState = this.setConfirmDeleteTagModalState.bind(this);
        this.onChangeTagManage = this.onChangeTagManage.bind(this);
        this.onUpdateTagManage = this.onUpdateTagManage.bind(this);

        this.unsubscribes = [ProjectStore.listen(this.onProjectStoreStateChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    getDefaultTagUpdates() {
        return {
            add: {
                activities: {},
                projects: {},
            },
            remove: {
                activities: {},
                projects: {},
            },
        };
    }

    onProjectStoreStateChange(storeState) {
        if (storeState.action.id === this.state.tagManageActionId) {
            let newState = {
                tagManageActionId: null,
                tagUpdates: this.getDefaultTagUpdates(),
                tagManageError: null,
            };

            if (storeState.action.error) {
                newState = { ...newState, tagManageError: storeState.action.error };
            }

            this.setState(newState);
        }
    }

    onChangeTagName(e) {
        this.setState({ newTagName: e.target.value });
    }

    onChangeTagDescription(e) {
        this.setState({ newTagDescription: e.target.value });
    }

    onUpdateTagName() {
        this.setConfirmUpdateTagModalState(false);
        if (!this.state.newTagName) {
            return;
        }

        OrganizationActions.updateOrgIntegrationTag(uuid.v4(), {
            orgId: this.props.tagRecord.user_id,
            tagId: this.props.tagRecord.id,
            tag: this.state.newTagName,
        });
    }

    onUpdateTagDescription() {
        OrganizationActions.updateOrgIntegrationTag(uuid.v4(), {
            orgId: this.props.tagRecord.user_id,
            tagId: this.props.tagRecord.id,
            description: this.state.newTagDescription,
        });
    }

    setConfirmUpdateTagModalState(showBool) {
        this.setState({ showConfirmUpdateTagModal: showBool });
    }

    setConfirmDeleteTagModalState(showBool) {
        this.setState({ showConfirmDeleteTagModal: showBool });
    }

    onChangeTagManage(newTagUpdatesObj) {
        this.setState({ tagUpdates: newTagUpdatesObj });
    }

    onUpdateTagManage() {
        const tagManageActionId = uuid.v4();
        this.setState({ tagManageActionId: tagManageActionId }, () => {
            OrganizationActions.manageOrgIntegrationTag(tagManageActionId, {
                orgId: this.props.tagRecord.user_id,
                tagId: this.props.tagRecord.id,
                managementTasks: this.state.tagUpdates,
            });            
        });
    }

    render() {
        let projectName = '';
        let canEdit = false;
        const useCount =0;

        const tagNameToEdit = typeof this.state.newTagName === 'string' ? this.state.newTagName : this.props.tagRecord.tag;
        let tagDescriptionToEdit = typeof this.state.newTagDescription === 'string' ? this.state.newTagDescription : this.props.tagRecord.description;
        tagDescriptionToEdit = tagDescriptionToEdit || ''; // overrride null values coming from server

        /*
        if (this.state.channelStoreState.initialized && this.state.projectStoreState.initialized) {
            const project = this.state.projectStoreState.project;
            const channel = this.state.channelStoreState.channelsAndOrgs.find(c => c.id === project.channelId);

            if (!PermissionsUtil.canViewProjectCollaborators(channel.user_permissions, project.user_permissions)) {
                return null;
            }

            canEditCollabs = PermissionsUtil.canEditProjectCollaborators(channel.user_permissions, project.user_permissions);
            isOrgProject = Globals.users.is_org_account_type(channel.channel_account_type_token);
            if (isOrgProject) {
                orgPossibleCollaborators = this.state.organizationMemberStoreState.members[channel.id];
            }

            projectName = project.name;
        }
        */

        const tagUpdatesHasChanges = (() => {
            if (!this.state.tagUpdates) return false;

            let changeTaskAreas = [
                this.state.tagUpdates.add.activities,
                this.state.tagUpdates.add.projects,
                this.state.tagUpdates.remove.activities,
                this.state.tagUpdates.remove.projects,
            ];

            let hasTasks = false
            changeTaskAreas.forEach((changeTaskArea) => {
                if (Object.keys(changeTaskArea).length > 0) hasTasks = true;
            });

            return hasTasks;
        })();

        return (
            <div className={`${this.props.className}`}>
                <div className="padding-lr-md">
                    <h3 className="heading-lg">{this.props.tagRecord.tag}</h3>
                    {this.props.tagRecord.description}
                    <hr className="medium hr-color-6"/>
                    <h4 className="margin-top-lg">Edit Integration Tag</h4>
                    <hr className="small hr-color-6"/>
                    <Form className="padding-tb-md">
                        <Form.Group controlId="new-tag-name">
                            <Form.Label>Tag Name</Form.Label>
                            <Tooltip id="orgte-tt" className="margin-left-sm" placement="right">
                                <div className="text-small">
                                    <TagNameInfo className="margin-bottom-sm" />
                                    <UpdateTagNameWarning />
                                </div>
                            </Tooltip>
                            <InputGroup>
                                <Form.Control
                                    value={tagNameToEdit}
                                    onChange={this.onChangeTagName}
                                />
                                <InputGroup.Append>
                                    <Button 
                                        variant="danger"
                                        disabled={!this.state.newTagName || tagNameToEdit === this.props.tagRecord.description}
                                        onClick={this.setConfirmUpdateTagModalState.bind(this, true)}
                                    >
                                        Update
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                    <Form className="padding-tb-md">
                        <Form.Group controlId="new-tag-description">
                            <Form.Label>Tag Description (optional)</Form.Label>
                            <Tooltip id="orgte-td" className="margin-left-sm" placement="right">
                                {Strings['en'].integration.TAG_DESCRIPTION_DESC}
                            </Tooltip>
                            <InputGroup>
                                <Form.Control
                                    value={tagDescriptionToEdit}
                                    onChange={this.onChangeTagDescription}
                                />
                                <InputGroup.Append>
                                    <Button
                                        disabled={tagDescriptionToEdit === this.props.tagRecord.description}
                                        onClick={this.onUpdateTagDescription}
                                    >
                                        Update
                                    </Button>
                                </InputGroup.Append>
                            </InputGroup>
                        </Form.Group>
                    </Form>
                    <div className="padding-tb-md fr">
                        <Button
                            variant="danger"
                            onClick={this.props.onDelete}
                        >
                            Delete Tag
                        </Button>
                    </div>
                    <div className="float-clear" />
                    <h4 className="margin-top-lg">
                        Manage Projects & Activities Using Integration Tag
                    </h4>
                    <hr className="small hr-color-6"/>
                    <ErrorBox error={this.state.tagManageError} />
                    <Button 
                        className="fr"
                        disabled={!tagUpdatesHasChanges || !!this.state.tagManageActionId}
                        onClick={this.onUpdateTagManage}
                    >
                        Confirm Changes
                    </Button>
                    <Button 
                        className="fr margin-right-lg"
                        disabled={!tagUpdatesHasChanges || !!this.state.tagManageActionId}
                        onClick={this.onChangeTagManage.bind(this, this.getDefaultTagUpdates())}
                    >
                        Reset Changes
                    </Button>
                    <div className="float-clear" />

                    <SelectableProjectsActivitiesTree 
                        channelId={this.props.tagRecord.user_id}
                        tagId={this.props.tagRecord.id}
                        onChange={this.onChangeTagManage}
                        tagUpdates={this.state.tagUpdates}
                    />
                </div>

                { this.state.showConfirmUpdateTagModal &&
                    <ConfirmModal
                        show={this.state.showConfirmUpdateTagModal}
                        modalTitle="Update Tag Name"
                        text={
                            <div className="font-size-14px">
                                <TagNameInfo className="margin-bottom-lg" />
                                <UpdateTagNameWarning /> 
                                <div className="margin-top-sm font-weight-bold text-centered">Are you sure you want to change the name of this tag?</div>
                            </div>
                        }
                        buttonText="confirm update"
                        confirmButtonBsStyle="danger"
                        confirmHandler={this.onUpdateTagName}
                        cancelButtonText="cancel"
                        cancelHandler={this.setConfirmUpdateTagModalState.bind(this, false)}
                        closeHandler={this.setConfirmUpdateTagModalState.bind(this, false)}
                    />
                }
            </div>
        );
    }
}

OrgIntegrationTagEditor.propTypes = propTypes;
OrgIntegrationTagEditor.defaultProps = defaultProps;

export default OrgIntegrationTagEditor;